<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <!-- <h1>{{ $t("Toolbar.rconsent") }}</h1> -->
            <h2>SMS</h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-3 pb-3>
          <v-flex xs11 lg11>
            <template>
              <v-stepper v-model="StatusBtn" class="rounded-lg">
                <v-stepper-items>
                  <v-stepper-content step="2">
                    2
                    <v-form ref="formConsent" v-model="valid" lazy-validation>
                      <v-card-title primary-title class="pa-2 pl-4">
                        <b>{{ $t("onechat.step1") }} &nbsp;</b>
                        <v-divider vertical></v-divider>
                        <b style="color: #077893"
                          >&nbsp;&nbsp;{{ $t("onechat.set") }}</b
                        >
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-2">
                        <v-layout row wrap justify-center pa-3>
                          <v-flex xs11 md4 lg4 pa-2>
                            <b>{{ $t("onechat.con1") }}</b> <br />
                            <div class="d-flex">
                              <v-radio-group
                                @change="Fn_SelectTypeDepartment"
                                v-model="TypeSent"
                                :rules="[
                                  (v) => !!v || 'กรุณาเลือกรูปแบบการส่ง',
                                ]"
                                row
                              >
                                <v-radio
                                  :label="$t('onechat.con2')"
                                  color="#077893"
                                  value="SentDepartment"
                                >
                                </v-radio>
                                <v-radio
                                  :label="$t('onechat.con3')"
                                  color="#077893"
                                  value="SentAll"
                                >
                                </v-radio>
                              </v-radio-group>
                            </div>
                            <b class="red--text mr-1">*</b>
                            <b>{{ $t("onechat.text1") }}</b>
                            <v-select
                              dense
                              :items="ItemsDepartment"
                              :label="$t('onechat.text2')"
                              :disabled="TypeSent === 'SentAll'"
                              :rules="[(v) => !!v || $t('onechat.text2')]"
                              item-text="DepartmentName"
                              return-object
                              v-model="SelectDepartment"
                              item-value="DepartmentId"
                              outlined
                            >
                            </v-select>
                            <b class="red--text mr-1">*</b>
                            <b>{{ $t("onechat.text3") }}</b>
                            <v-select
                              dense
                              return-object
                              :items="ItemsPosition"
                              :label="
                                ItemsPosition.length === 0
                                  ? 'ไม่พบข้อมูลตำแหน่ง'
                                  : $t('onechat.text4')
                              "
                              :disabled="
                                DisabledPosition || ItemsPosition.length === 0
                              "
                              v-model="SelectRole"
                              item-text="RoleName"
                              item-value="RoleId"
                              :rules="[(v) => !!v || $t('onechat.text4')]"
                              outlined
                            >
                            </v-select>
                          </v-flex>
                          <v-flex lg1 pa-2></v-flex>
                          <v-flex
                            xs11
                            lg6
                            md6
                            pa-2
                            v-if="
                              TypeSent === 'SentAll' || DepartmentId === '00000'
                            "
                          >
                            <b>{{ $t("onechat.consentlist") }}</b>
                            <v-card
                              outlined
                              class="overflow-y-auto elevation-0 mt-2"
                              max-height="250"
                            >
                              <v-text-field
                                v-model="Search"
                                append-icon="mdi-magnify"
                                :label="$t('consentlist.search')"
                                single-line
                                hide-details
                              ></v-text-field>
                              <v-data-table
                                :headers="HeadersRule"
                                :items="ItemsPosition"
                                calculate-widths
                                class="overflow-y-auto elevation-0"
                                show-select
                                v-model="SelectNamePosition"
                                item-key="NameTh"
                                :search="Search"
                                hide-default-footer
                              >
                                <template
                                  v-slot:body
                                  v-if="LoadingPosition === true"
                                >
                                  <tr>
                                    <td colspan="12">
                                      <br />
                                      <center>
                                        <v-progress-circular
                                          :size="30"
                                          :width="5"
                                          color="#077893"
                                          indeterminate
                                        >
                                        </v-progress-circular>
                                      </center>
                                    </td>
                                  </tr>
                                </template>
                                <template v-slot:[`item.Name`]="{ item }">
                                  <div v-if="$t('default') === 'th'">
                                    {{ item.NameTh }}
                                  </div>
                                  <div v-else>
                                    {{ item.NameEng }}
                                  </div>
                                </template>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                          <v-flex xs11 lg4 pa-2 v-else-if="SelectRole">
                            <b>{{ $t("onechat.consentlist") }} </b>
                            <v-card
                              class="overflow-y-auto elevation-0"
                              max-height="200"
                            >
                              <v-data-table
                                :headers="HeadersPosition"
                                :items="ItemsPosition"
                                calculate-widths
                                class="overflow-y-auto elevation-0"
                                show-select
                                v-model="SelectNamePosition"
                                item-key="NameTh"
                                hide-default-footer
                              >
                                <template
                                  v-slot:body
                                  v-if="LoadingPosition === true"
                                >
                                  <tr>
                                    <td colspan="12">
                                      <br />
                                      <center>
                                        <v-progress-circular
                                          :size="30"
                                          :width="5"
                                          color="#077893"
                                          indeterminate
                                        >
                                        </v-progress-circular>
                                      </center>
                                    </td>
                                  </tr>
                                </template>
                                <template v-slot:[`item.Name`]="{ item }">
                                  <div v-if="$t('default') === 'th'">
                                    {{ item.NameTh }}
                                  </div>
                                  <div v-else>
                                    {{ item.NameEng }}
                                  </div>
                                </template>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                          <v-flex xs11 lg6 pa-2 v-else></v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-form>
                    <v-card-actions class="pa-2">
                      <v-layout
                        row
                        wrap
                        justify-end
                        align-center
                        :justify-center="$vuetify.breakpoint.smAndDown"
                        pa-2
                      >
                        <v-flex xs10 md2 lg2>
                          <v-btn
                            block
                            dark
                            color="#077893"
                            @click="Fn_NextPage"
                            :disabled="SelectNamePosition == ''"
                          >
                            {{ $t("onechat.next") }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-card-title primary-title class="pa-2 pl-4">
                        <b>{{ $t("onechat.step2") }} &nbsp;</b>
                        <v-divider vertical></v-divider>
                        <b style="color: #077893"
                          >&nbsp;&nbsp;{{ $t("onechat.text5") }}</b
                        >
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="pa-2">
                        <v-layout row wrap justify-center align-center>
                          <v-flex xs11 lg11 pa-2>
                            <v-radio-group
                              @change="Fn_SelectTypeDepartment"
                              v-model="ConsentType"
                              row
                            >
                              <v-radio
                                :label="$t('onechat.text6')"
                                color="#077893"
                                value="SentGeneral"
                              >
                              </v-radio>
                              <v-radio
                                :label="$t('onechat.text7')"
                                color="#077893"
                                value="SentGroup"
                              >
                              </v-radio>
                            </v-radio-group>
                          </v-flex>
                          <v-flex
                            xs11
                            lg5
                            pa-2
                            v-if="ConsentType === 'SentGeneral'"
                          >
                            <b class="red--text mr-1">*</b>
                            <b>{{ $t("onechat.text8") }} </b>
                            <v-select
                              dense
                              :items="ItemPolicy"
                              :label="$t('onechat.text8')"
                              :rules="[(v) => !!v]"
                              item-text="Title"
                              v-model="SelectPolicy"
                              item-value="PolicyId"
                              outlined
                            >
                            </v-select>
                            <b class="red--text mr-1">*</b>
                            <b>{{ $t("onechat.text9") }} </b>
                            <v-select
                              v-if="ConsentType === 'SentGeneral'"
                              dense
                              :items="ItemConsentGeneral"
                              :label="$t('onechat.text8')"
                              :rules="[(v) => !!v]"
                              item-text="HeaderConsent"
                              v-model="SelectConsentGeneral"
                              item-value="ConsentId"
                              outlined
                            >
                            </v-select>
                          </v-flex>
                          <v-flex
                            xs11
                            lg5
                            pa-2
                            v-if="ConsentType === 'SentGroup'"
                          >
                            <b class="red--text mr-1">*</b>
                            <b>{{ $t("onechat.text9") }} </b>
                            <v-select
                              dense
                              :items="ItemConsentGroup"
                              :label="$t('onechat.text9')"
                              :rules="[(v) => !!v]"
                              item-text="GroupName"
                              v-model="SelectConsentGroup"
                              item-value="GroupId"
                              outlined
                            >
                            </v-select>
                          </v-flex>
                          <v-flex xs11 lg6></v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-form>
                    <v-card-actions>
                      <v-layout
                        row
                        wrap
                        :justify-space-between="$vuetify.breakpoint.lgAndUp"
                        align-center
                        pa-2
                        :justify-center="$vuetify.breakpoint.smAndDown"
                      >
                        <v-flex xs11 md2 lg2>
                          <v-btn
                            block
                            dark
                            color="#077893"
                            @click="StatusBtn = 1"
                          >
                            {{ $t("onechat.back") }}
                          </v-btn>
                        </v-flex>
                        <v-flex xs11 md2 lg2>
                          <v-btn
                            block
                            dark
                            color="#077893"
                            :loading="LoadingSentConsent"
                            @click="Fn_Save()"
                          >
                            {{ $t("onechat.send") }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </template>
          </v-flex>
        </v-layout>
        <!-- <LogOnechat /> -->
        <SearchConsentLogOnechatIndex />
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogListGeneralConsent
        :show="DialogList"
        :_detail="ItemsListConsent"
        @closeDialogDelete="DialogList = false"
      />
      <DialogListGroupConsent
        :show="DialogListGroup"
        :_detail="ItemsListConsent"
        @closeDialogDelete="DialogListGroup = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import DialogListGeneralConsent from "@/components/dialog/ConsentOnechat/DialogConsentGeneralOnechatCreate.vue";
import DialogListGroupConsent from "@/components/dialog/DialogConsentGroupOnechatCreate";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { mapGetters } from "vuex";
// import LogOnechat from "../Consent/ConsentOnechat/LogOnechat/ConsentLogOnechatIndex.vue";
import SearchConsentLogOnechatIndex from "../Consent/ConsentOnechat/LogOnechat/SearchConsentLogOnechatIndex.vue";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    DialogListGeneralConsent,
    DialogListGroupConsent,
    // LogOnechat,
    OverlaySearch,
    SearchConsentLogOnechatIndex,
  },
  data: function () {
    return {
      valid: true,
      DialogList: false,
      loadingDownloadData: true,
      Title: "",
      RejectReason: "",
      DetailConsent: "",
      ExpirationDate: "",
      DepartmentId: "",
      ConsentType: "SentGeneral",
      DisabledPosition: false,
      SelectNamePosition: [],
      TypeSent: "",
      LoadingPosition: false,
      LoadingSentConsent: false,
      DialogListGroup: false,
      StatusBtn: 1,
      rows: [{ row: "" }],
      ItemsDepartment: [
        {
          BusinessId: "00000",
          DepartmentId: "00000",
          DepartmentName: this.$i18n.t("onechat.all1"),
        },
      ],
      ItemsPosition: [],
      ItemPolicy: [],
      ItemConsentGeneral: [],
      ItemConsentGroup: [],
      ItemsListConsent: [],
      SelectPolicy: "",
      SelectConsentGeneral: "",
      SelectConsentGroup: " ",
      SelectDepartment: "",
      SelectRole: "",
      TextPolicy: "",
      TextConsent: "",
      Search: "",
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _SelectBusinessId: {
      get() {
        return this.Business.BusinessId || "-";
      },
    },
    _SelectTaxId: {
      get() {
        return this.Business.TaxId || "-";
      },
    },
    _SelectAccessToken: {
      get() {
        return this.$cookies.get("OneAccessToken") || "-";
      },
    },
    _BusinessName: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
    HeadersRule() {
      return [
        {
          text: "ทุกคน",
          align: "start",
          sortable: false,
          value: "Name",
        },
      ];
    },
    HeadersPosition() {
      return [
        {
          text: "ทุกตำแหน่ง",
          align: "start",
          sortable: false,
          value: "Name",
        },
      ];
    },
  },
  mounted() {
    this.Fn_ChangeTypeText();
    setTimeout(() => (this.loadingDownloadData = false), 500);
  },
  methods: {
    Fn_ChangeTypeText() {
      if (this.ConsentType === "SentGeneral") {
        this.TextPolicy = "เลือกนโยบายแบบทั่วไป";
        this.TextConsent = "เลือกความยินยอมแบบทั่วไป";
      } else if (this.ConsentType === "SentGroup") {
        this.TextPolicy = "เลือกนโยบายแบบกลุ่ม";
        this.TextConsent = "เลือกความยินยอมแบบกลุ่ม";
      }
    },
    Fn_BackIndex() {
      this.$router.push("/consent-index-create");
    },
    Fn_SelectTypeDepartment() {
      if (this.TypeSent === "SentDepartment") {
        this.Fn_GetAllDepartment();
      } else if (this.TypeSent === "SentAll") {
        this.SelectDepartment = "";
        this.SelectRole = "";
        this.$refs.formConsent.resetValidation();
        this.Fn_GetAllEmployee();
      }
    },
    Fn_NextPage() {
      // if (this.$refs.formConsent.validate()) {
      this.StatusBtn = 2;
      this.Fn_GetPolicy();
      this.Fn_GetConsentGeneral();
      this.Fn_GetConsentGroup();
      // }
    },
    async Fn_GetAllDepartment() {
      var payload = {
        TaxId: this._SelectTaxId,
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetAllDepartment",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            for (var i in response.data.Message) {
              var x = response.data.Message[i];
              this.ItemsDepartment.push(x);
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetDetailDepartment() {
      this.LoadingPosition = true;
      this.ItemsPosition = [];

      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        DepartmentId: this.SelectDepartment.DepartmentId,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetDetailDepartment",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingPosition = false;
          if (response.data.Status === "OK") {
            for (var i in response.data.Message) {
              var x = response.data.Message[i];
              this.ItemsPosition.push(x);
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingPosition = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.catch"),
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetAllEmployee() {
      // if (this.TypeSent == "SentAll") {
      this.LoadingPosition = true;
      // this.SelectNamePosition = []
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/GetAllEmployee",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingPosition = false;
          if (response.data.Status === "OK") {
            for (var i in response.data.Message) {
              var x = response.data.Message[i];
              this.ItemsPosition.push(x);
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingPosition = false;

          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
      // } else {
      //   Toast.fire({
      //     icon: "warning",
      //     title: "กรุณาเลือกรูปแบบการส่ง",
      //   });
      // }
    },
    async Fn_GetAllEmployeeFromDepartment() {
      this.LoadingPosition = true;
      this.SelectNamePosition = [];
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetAllEmployeeFromAllDepartment",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingPosition = false;
          if (response.data.Status === "OK") {
            this.ItemsPosition = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingPosition = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGeneral() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemConsentGeneral = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGroup() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsentGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_Save() {
      if (this.$refs.form.validate()) {
        if (this.ConsentType === "SentGeneral") {
          this.SelectConsentGroup = "";
        } else if (this.ConsentType === "SentGroup") {
          this.SelectConsentGeneral = "";
        }
        this.LoadingSentConsent = true;
        var payload = {
          UserName: this.$cookies.get("OneUsername"),
          BusinessId: this.$cookies.get("BusinessId"),
          AccountId: this.$cookies.get("OneAccountId"),
          Receiver: this.SelectNamePosition,
          ConsentGroupId: this.SelectConsentGroup,
          Consent: this.SelectConsentGeneral,
          PolicyId: this.SelectPolicy,
          UserId: this.$cookies.get("OneAccountId"),
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/GetConsent",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.LoadingSentConsent = false;
            if (response.data.Status === "OK") {
              if (this.SelectConsentGroup === "") {
                this.DialogList = true;
              } else {
                this.DialogListGroup = true;
              }
              this.ItemsListConsent = response.data.Message;
            } else {
              this.LoadingSentConsent = false;
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.LoadingSentConsent = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
  },
  created() {},
  watch: {
    TypeSent(val) {
      if (val === "SentAll") {
        this.$refs.formConsent.resetValidation();
        this.DisabledPosition = true;
      }
    },
    SelectDepartment(val) {
      if (val.DepartmentId === "00000") {
        this.Fn_GetAllEmployeeFromDepartment();
        this.SelectRole = "00000";
        this.DepartmentId = "00000";
        this.$refs.formConsent.resetValidation();
        this.DisabledPosition = true;
      } else if (this.TypeSent === "SentAll") {
        this.SelectRole = "";
        this.DisabledPosition = false;
      } else {
        this.SelectRole = "";
        this.DisabledPosition = false;
        this.Fn_GetDetailDepartment();
      }
    },
    ConsentType(val) {
      if (val === "SentGeneral") {
        this.TextPolicy = "เลือกนโยบายแบบทั่วไป";
        this.TextConsent = "เลือกความยินยอมแบบทั่วไป";
      } else if (val === "SentGroup") {
        this.TextPolicy = "เลือกนโยบายแบบกลุ่ม";
        this.TextConsent = "เลือกความยินยอมแบบกลุ่ม";
      }
    },
    // '$i18n.locale': function (val) {
    //   this.Fn_GetAllDepartment()
    //   this.Fn_GetAllEmployee()
    //   this.Fn_GetDetailDepartment()
    //   this.Fn_GetAllEmployeeFromDepartment()
    // }
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.v-stepper__content {
  padding: 0 !important;
}

.c-border {
  border-style: solid;
  border-color: #87e8de !important;
  border-width: 1px;
}

.--text {
  color: #13c2c2;
}

.ff3296--text {
  color: #ff3296;
}
</style>

<style>
input#input-45,
input#input-50 {
  cursor: pointer !important;
}
</style>
